import { NavLink, useLocation } from "react-router-dom";
import { Icon } from "./icons";
import { useAuth } from "../auth";
import { coverUri } from "../lib/api";
import { initials } from "../lib/format";
import { ReminderBanner } from "./ReminderBanner";
import { adminNavFor } from "../lib/permissions";
import { MiniPlayer } from "./MiniPlayer";
import { useLiveSync } from "../lib/liveSync";

const TABS = [
  { to: "/", label: "Início", icon: "home", end: true },
  { to: "/calendar", label: "Calendário", icon: "calendar-outline" },
  { to: "/repertorio", label: "Repertório", icon: "library" },
  { to: "/estudar", label: "Estudar", icon: "mic" },
  { to: "/naipe", label: "Naipe", icon: "chatbubbles-outline" },
  { to: "/perfil", label: "Perfil", icon: "person" },
];

function Avatar({ user, size = 38 }) {
  const url = coverUri(user?.photo_url);
  return (
    <div className="avatar" style={{ width: size, height: size, fontSize: size * 0.36 }}>
      {url ? <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : initials(user?.name)}
    </div>
  );
}

export function AppShell({ children }) {
  const { user } = useAuth();
  const adminNav = adminNavFor(user);
  const loc = useLocation();
  const online = useLiveSync(user?.id);

  return (
    <div className="shell app-root">
      <aside className="sidebar" data-testid="desktop-sidebar">
        <div className="side-brand">
          <div className="b-kicker">COMUNIDADE PRIVADA</div>
          <div className="b-name">URBAN<br />LISBON<br />CHOIR</div>
          <div className="b-bar" />
        </div>
        <nav className="side-nav">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} data-testid={`nav-${t.label.toLowerCase()}`}>
              <Icon name={t.icon} size={19} />
              {t.label}
            </NavLink>
          ))}
          {adminNav.length ? (
            <>
              <div className="nav-label">Administração</div>
              {adminNav.map((t) => (
                <NavLink key={t.to} to={t.to} className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`} data-testid={t.testid}>
                  <Icon name={t.icon} size={19} />
                  {t.label}
                </NavLink>
              ))}
            </>
          ) : null}
        </nav>
        <div className="side-foot">
          <Avatar user={user} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontFamily: "var(--f-medium)", fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{user?.name}</div>
            <div style={{ color: "var(--muted)", fontSize: 11 }}>{user?.voice || "Sem voz"}</div>
          </div>
        </div>
      </aside>

      <div className="main">
        {!online ? (
          <div role="status" data-testid="offline-banner" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px", background: "var(--warning)", color: "var(--on-warning)", fontSize: 13 }}>
            <Icon name="offline" size={15} /> Sem ligação ao servidor — a mostrar os últimos dados carregados. A tentar novamente…
          </div>
        ) : null}
        <ReminderBanner />
        <div className="scroll-area" key={loc.pathname}>
          {children}
        </div>
        <div className="bottom-dock">
        <MiniPlayer />
        <nav className="tabbar" data-testid="mobile-tabbar" aria-label="Navegação principal">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.end} className={({ isActive }) => (isActive ? "active" : "")} data-testid={`tab-${t.label.toLowerCase()}`}>
              {({ isActive }) => (
                <>
                  <Icon name={t.icon} size={22} color={isActive ? "var(--on-surface)" : "var(--muted)"} />
                  <span>{t.label}</span>
                  <span className="tab-dot" />
                </>
              )}
            </NavLink>
          ))}
        </nav>
        </div>
      </div>
    </div>
  );
}

export { Avatar };
